import React from 'react';
export default ({ text, label }) => (
    <div
        style={{
            minHeight: 56,
            maxHeight: 56,
            padding: '0px 15px',
            color: 'rbga(255,255,255,0.5)',
            fontWeight: 400,
        }}
    >
        <h3 style={{ fontWeight: 400 }}>
            {label && <span style={{ color: '#00a0b5' }}>{label}</span>} {text}
        </h3>
    </div>
);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/controls/Header.js
 **/